import { Button, CheckIconV2, DocxIcon, LoadingSpinner } from '@repo/atomic-components';
import type { DraftSaveState } from '@/ui/features/chat/projectChat';

const CARD_BUTTON_CLASS =
  '!border-theme-border-grey !bg-theme-white !text-theme-black hover:!bg-theme-background-grey flex h-8 shrink-0 items-center gap-2 rounded-[4px] border px-3 text-xs font-semibold disabled:!opacity-100 disabled:hover:!bg-theme-white';

interface DraftArtefactCardProps {
  fileName: string;
  saveState: DraftSaveState;
  onOpen: () => void;
  onSave: () => void;
}

/** A draft the AI generated in a project chat, with Open and Save to project. */
export const DraftArtefactCard = ({ fileName, saveState, onOpen, onSave }: DraftArtefactCardProps) => (
  <div
    style={{ borderColor: 'rgba(74, 126, 231, 0.4)' }}
    className="bg-theme-white text-theme-black flex w-fit max-w-full flex-wrap items-center gap-x-3 gap-y-2 rounded-md border px-4 py-3"
  >
    <div className="flex min-w-0 items-center gap-3">
      <DocxIcon width={30} height={20} className="shrink-0" aria-hidden />
      <span className="max-w-65 min-w-0 truncate text-sm font-semibold">{fileName}</span>
    </div>
    <div className="flex items-center gap-2">
      <Button outlined className={CARD_BUTTON_CLASS} onClick={onOpen} aria-label={`Open ${fileName}`}>
        Open
      </Button>
      <Button
        outlined
        className={CARD_BUTTON_CLASS}
        onClick={onSave}
        disabled={saveState !== 'unsaved'}
        aria-busy={saveState === 'checking' || saveState === 'saving'}
        aria-label={saveState === 'saved' ? `${fileName} saved to project` : `Save ${fileName} to project`}
      >
        {saveState === 'saving' && <LoadingSpinner size={13} className="!h-[13px] !w-[13px]" />}
        {saveState === 'saved' && <CheckIconV2 width={13} height={13} aria-hidden />}
        {saveState === 'saved' ? 'Saved to project' : 'Save to project'}
      </Button>
    </div>
  </div>
);
